/* Name:Chaitali Khachane
   Description:This is the Asset Summary screen, which will show the all detail information about the 
   select Asset like Asset name, description, region, country, product owner etc.
   In this page user will also able to view sample data by click on view Sample data link 
   and dashboard also by click on View  Dashboard button -this will open the new tab of powerBI dashboarrdlink.
   as well as user will able view the value of active rule, succesful run, freshness, quality score, las update
   which value we will get from API.
*/

import ReactECharts from 'echarts-for-react';
import { Button } from "primereact/button";
import { Tooltip } from "primereact/tooltip";
import React, { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import dashboardImage from "../../assests/dashboard.svg";
import { getOption } from "../../charts/getChartOption";
import CardComp from "../../component/card/cardComp";
import { LabelHeading } from "../../component/LabelHeader/labelHeader.style";
import { theme } from "../../theme/theme";
import { CardBodyTitle, Container, GlobalCardTitle, UnderlineGlobalValue } from "../global/global.style";
import { CardTitle, CardValue } from "./dataAssets.style";
import SampleDataPopUp from "./sampleDataPopUp";
import { Calendar } from 'primereact/calendar';
import { ProgressSpinner } from 'primereact/progressspinner';
import { toTitleCase } from '../../helper';
import { SET_FORM_OPTIONOBJECTS_OBJECT_VALUE } from '../../redux/dataAsset/dataAsset.type';
import { getdataAsset } from '../../redux/dataAsset/dataAsset.action';
import ReloadDataAssetFile from './reloadDataAssetFile';
import AssetSummaryTagPopUp from './assetSummaryTagPopUp';
import { rolePermissionMapping } from "../../data/userAccess/userRoleMapping"
import { checkButtonDisabledStatus } from "../../helpers/validation/userValidation"
import { useMemo } from "react"
import { FloatLabel } from 'primereact/floatlabel';
import { filterAndMapScores } from '../../helpers/dateGenerator';

function AssetSummary({ dataAssetId, changeDetail }) {
   const { apiData, formData } = useSelector((state) => state.dataAsset)
   const [enableSampleData, setEnableSampleData] = useState(false)
   const [reUploadEnable, setReUploadEnable] = useState(false)
   const [tagEnable, setTagEnable] = useState(false)

   const cardHeight = undefined
   const CardSectionHeight = undefined
   //  (cardHeight - (40 + 28 + 5 + 10 + 3)) / 2
   const dispatch = useDispatch()
   const [trendOption1, setTrendOption1] = useState('Last 7 Days')
   const [trendOption2, setTrendOption2] = useState('Last 15 Days')
   const [trendOption3, setTrendOption3] = useState('Last 30 Days')
   const [dates, setDates] = useState(null);
   const [maxYAxis, setMaxYAxis] = useState(100)
   const [currentDisplayButton, setCurrentDisplayButton] = useState("Last Week")
   const [calenderVisible, setCalenderVisible] = useState(false)

   useEffect(() => {
   
      if (apiData.assetSummary.data.frequency === 'DAILY') {
         setTrendOption1('Last 7 Days')
         setTrendOption2('Last 15 Days')
         setTrendOption3('Last 30 Days')
   setCurrentDisplayButton('Last 7 Days')
      } else if (apiData.assetSummary.data.frequency === 'MONTHLY') {
         setTrendOption1('Last 3 Months')
         setTrendOption2('Last 6 Months')
         setTrendOption3('Last 12 Months')
         setCurrentDisplayButton('Last 3 Months')
      } else if (apiData.assetSummary.data.frequency === 'WEEKLY') {
         setTrendOption1('Last 4 Weeks')
         setTrendOption2('Last 12 Weeks')
         setTrendOption3('Last 24 Weeks')
         setCurrentDisplayButton('Last 4 Weeks')
      }

   }, [apiData.assetSummary.data])

   //this method will open the new tab with powerBI dashbaord link
   const OpenLinkButton = () => {
      window.open(process.env.REACT_APP_API_POWERBIDASHBOARD, '_blank');
   };
   const getMinDate = () => {
      const dates = apiData.assetSummary.data.chartData.displayFields.map(date => new Date(date));
      const minDate = new Date(Math.min(...dates));
      return minDate
      // .toISOString().split('T')[0]
   }
   const getMaxDate = () => {
      const dates = apiData.assetSummary.data.chartData.displayFields.map(date => new Date(date));
      const maxDate = new Date(Math.max(...dates));
      return maxDate


   }
   const getTextColor = (title, value) => {
      if (title === 'Freshness' || title === 'Total Quality Score') {
         return parseFloat(value) <= 90 ? theme.colors.fail : parseFloat(value) > 95 ? theme.colors.success : theme.colors.yellow
      }
      return theme.colors.primary
   }
   const updateChartTime = (timeLabel, timeValue) => {
      const tempdates = apiData.assetSummary.data.chartData.displayFields.map(date => new Date(date));
      // Convert the string dates into Date objects
      const today = new Date();
      const requiredTimeAgo = new Date(today);
      let updatedDates = []
      let updatedValues = []

      if (timeLabel === "Last 3 Months") {
         requiredTimeAgo.setMonth(today.getMonth() - 3);
      } else if (timeLabel === "Last 6 Months") {
         requiredTimeAgo.setMonth(today.getMonth() - 6);
      } else if (timeLabel === "Last 12 Months") {
         requiredTimeAgo.setMonth(today.getMonth() - 12);
      } else if (timeLabel === 'Last 7 Days') {
         requiredTimeAgo.setDate(today.getDate() - 7);
      } else if (timeLabel === "Last 15 Days") {
         requiredTimeAgo.setDate(today.getDate() - 15);
      } else if (timeLabel === "Last 30 Days") {
         requiredTimeAgo.setDate(today.getDate() - 30);
      } else if (timeLabel === "Last 4 Weeks") {
         requiredTimeAgo.setDate(today.getDate() - 28);
      } else if (timeLabel === "Last 12 Weeks") {
         requiredTimeAgo.setDate(today.getDate() - 84);
      } else if (timeLabel === "Last 24 Weeks") {
         requiredTimeAgo.setDate(today.getDate() - (24 * 7));
      }
      tempdates.map((date, index) => {
         if (timeLabel === "Last 3 Months") {
            if (date >= requiredTimeAgo && date <= today) {
               updatedValues.push(apiData.assetSummary.data.chartData.displayValue[index])
               updatedDates.push(date)
            }
         }
         else if (timeLabel === "Last 6 Months") {
            if (date >= requiredTimeAgo && date <= today) {
               updatedValues.push(apiData.assetSummary.data.chartData.displayValue[index])
               updatedDates.push(date)
            }
         }
         else if (timeLabel === "Last 12 Months") {
            if (date >= requiredTimeAgo && date <= today) {
               updatedValues.push(apiData.assetSummary.data.chartData.displayValue[index])
               updatedDates.push(date)
            }
         } else if (timeLabel === "custom") {
            if (timeValue[0] !== null && timeValue[1] !== null) {
               if (date >= timeValue[0] && date <= timeValue[1]) {
                  updatedValues.push(apiData.assetSummary.data.chartData.displayValue[index])
                  updatedDates.push(date)
               }
            }

         }
      }
      );
      const formattedDates = updatedDates.map(date => {
         const day = String(date.getDate()).padStart(2, '0'); // Adds leading zero if single digit
         const month = String(date.getMonth() + 1).padStart(2, '0'); // `getMonth()` is zero-indexed, so add 1
         const year = date.getFullYear();

         return `${day}-${month}-${year}`; // Format as DD-MM-YYYY
      });
      dispatch({
         type: SET_FORM_OPTIONOBJECTS_OBJECT_VALUE,
         payload: {
            formField: "chartData",
            optionField: "displayFields",
            value: formattedDates
         }
      })
      dispatch({
         type: SET_FORM_OPTIONOBJECTS_OBJECT_VALUE,
         payload: {
            formField: "chartData",
            optionField: "displayValue",
            value: updatedValues
         }
      })
   }
  
   const access = apiData?.assetSummary?.data?.access || [];  // Use empty array as fallback
   const role = access?.[0]?.role_permission_id; 
   const isDisabledReupload = useMemo(() => {
      return role
        ? checkButtonDisabledStatus(
            access,
            role,
            "Re-upload Sample Data",
            rolePermissionMapping?.[role]?.buttons || {}
          )
        : true;
    }, [role, access, rolePermissionMapping]);


    const [chartOptions, setchartOptions] = useState({})
    useEffect(() => {
    if(apiData?.assetSummary?.data?.metrics?.quality_score_trend?.length){
      let chartData=filterAndMapScores(currentDisplayButton,apiData?.assetSummary?.data?.metrics?.quality_score_trend,dates)

     return  setchartOptions(chartData)
    }

    setchartOptions({})
    
     
    }, [apiData?.assetSummary?.data,currentDisplayButton,dates])
    
   return <Fragment>
      {apiData.assetSummary.loading || apiData.assetSummary.status === "idle" ?
         <div style={{ width: "100%", textAlign: "center", lineHeight: window.innerHeight + "px", verticalAlign: "middle" }}><ProgressSpinner /></div>
         :
         <Container style={{ height: "90%" }}>
            <div className="grid">
               <div className="col-8">
                  <LabelHeading>Asset Summary</LabelHeading>
               </div>
               <div className="col-4" style={{ textAlign: "right" }}>
                  <Tooltip target=".my-button" content="Click to open the detailed data quality dashboard." position="top" />
                  <Tooltip target=".my-tag" content="Under Construction." position="top" />

                  <Button
                     type="button"
                     label="Tag"
                     onClick={() => setTagEnable(true)}
                     style={{ marginRight: "10px", height: "40px" }}
                     className='my-tag'
                  />
            
                  <Button
                     disabled={isDisabledReupload}
                     type="button"
                     label="Re-Upload"
                     // icon={<img style={{ margin: "0px 2px" }} src={dashboardImage} />}
                     onClick={() => setReUploadEnable(true)}
                     style={{ marginRight: "10px", height: "40px" }}
                  // iconPos="right"
                  />
                  <Button
                     type="button"
                     label="View Dashboard"
                     icon={<img style={{ margin: "0px 2px" }} src={dashboardImage} />}
                     outlined onClick={OpenLinkButton}
                     style={{ marginRight: "10px", height: "40px" }}
                     iconPos="right"
                     className="my-button"
                  />
                  <Button style={{ width: "43px", height: "40px" }} icon="pi pi-refresh" onClick={() => { dispatch(getdataAsset(dataAssetId)) }} outlined />


               </div>
            </div>
            <div style={{ display: "flex", justifyContent: "space-between", width: "100%", gap: "10px" }}>
               <Fragment>
                  <CardComp style={{ width: "18%", margin: "0px" }} title={
                     <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <CardTitle>{toTitleCase("active_rules")}</CardTitle>
                        <div style={{ marginRight: '10px' }}>
                           <Tooltip target=".custom-target-icon" />
                           <i className="custom-target-icon pi pi-info-circle p-text-secondary p-overlay-badge"
                              data-pr-tooltip={"Number of active data quality rules applied to this asset."}
                              data-pr-position="top"
                              style={{ cursor: 'pointer', color: theme.colors.primary }}
                           >
                           </i>
                        </div>
                     </div>
                  }>
                     <CardValue style={{ padding: "0 10px 10px 10px", color: getTextColor("active_rules", apiData.assetSummary.data.metrics["active_rules"]) }}>{apiData.assetSummary.data.metrics["active_rules"]}</CardValue>
                  </CardComp>
               </Fragment>
               <Fragment>
                  <CardComp style={{ width: "18%", margin: "0px" }} title={
                     <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <CardTitle>{toTitleCase("successful_runs_in_last_30_days")}</CardTitle>
                        <div style={{ marginRight: '10px' }}>
                           <Tooltip target=".custom-target-icon" />
                           <i className="custom-target-icon pi pi-info-circle p-text-secondary p-overlay-badge"
                              data-pr-tooltip={"Count of successful data quality checks in the past month."}
                              data-pr-position="top"
                              style={{ cursor: 'pointer', color: theme.colors.primary }}
                           >
                           </i>
                        </div>
                     </div>
                  }>
                     <CardValue style={{ padding: "0 10px 10px 10px", color: getTextColor("successful_runs_in_last_30_days", apiData.assetSummary.data.metrics["successful_runs_in_last_30_days"]) }}>{apiData.assetSummary.data.metrics["successful_runs_in_last_30_days"]}</CardValue>
                  </CardComp>
               </Fragment>
               <Fragment>
                  <CardComp style={{ width: "18%", margin: "0px" }} title={
                     <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <CardTitle>{toTitleCase("freshness")}</CardTitle>
                        <div style={{ marginRight: '10px' }}>
                           <Tooltip target=".custom-target-icon" />
                           <i className="custom-target-icon pi pi-info-circle p-text-secondary p-overlay-badge"
                              data-pr-tooltip={"Indicates how up-to-date the data is, with 100% being the freshest."}
                              data-pr-position="top"
                              style={{ cursor: 'pointer', color: theme.colors.primary }}
                           >
                           </i>
                        </div>
                     </div>
                  }>
                     <CardValue style={{ padding: "0 10px 10px 10px", color: getTextColor("freshness", apiData.assetSummary.data.metrics["freshness"]) }}>{apiData.assetSummary.data.metrics["freshness"]}</CardValue>
                  </CardComp>
               </Fragment>
               <Fragment>
                  <CardComp style={{ width: "18%", margin: "0px" }} title={
                     <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <CardTitle>{toTitleCase("total_quality_score")}</CardTitle>
                        <div style={{ marginRight: '10px' }}>
                           <Tooltip target=".custom-target-icon" />
                           <i className="custom-target-icon pi pi-info-circle p-text-secondary p-overlay-badge"
                              data-pr-tooltip={"Overall data quality score based on multiple quality dimensions."}
                              data-pr-position="top"
                              style={{ cursor: 'pointer', color: theme.colors.primary }}
                           >
                           </i>
                        </div>
                     </div>

                  }>
                     <CardValue style={{ padding: "0 10px 10px 10px", color: getTextColor("total_quality_score", apiData.assetSummary.data.metrics["total_quality_score"]) }}>{apiData.assetSummary.data.metrics["total_quality_score"] ?? 'NA'}</CardValue>
                  </CardComp>
               </Fragment>
               <Fragment>
                  <CardComp style={{ width: "18%", margin: "0px" }} title={
                     <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <CardTitle>{toTitleCase("last_updated")}</CardTitle>
                        <div style={{ marginRight: '10px' }}>
                           <Tooltip target=".custom-target-icon" />
                           <i className="custom-target-icon pi pi-info-circle p-text-secondary p-overlay-badge"
                              data-pr-tooltip={"The last time this data asset was refreshed or updated."}
                              data-pr-position="top"
                              style={{ cursor: 'pointer', color: theme.colors.primary }}
                           >
                           </i>
                        </div>
                     </div>
                  }>
                     <CardValue style={{ padding: "0 10px 10px 10px", color: getTextColor("last_updated", apiData.assetSummary.data.metrics["last_updated"]) }}>{apiData.assetSummary.data.metrics["last_updated"]}</CardValue>
                  </CardComp>
               </Fragment>

               <Fragment>
                  <CardComp style={{ width: "18%", margin: "0px" }} title={
                     <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <CardTitle>{toTitleCase("last_rule_executed_on")}</CardTitle>
                        <div style={{ marginRight: '10px' }}>
                           <Tooltip target=".custom-target-icon" />
                           <i className="custom-target-icon pi pi-info-circle p-text-secondary p-overlay-badge"
                              data-pr-tooltip={"The last time the rule was executed for this data asset."}
                              data-pr-position="top"
                              style={{ cursor: 'pointer', color: theme.colors.primary }}
                           >
                           </i>
                        </div>
                     </div>
                  }>
                     <CardValue style={{ padding: "0 10px 10px 10px", 
                        color: getTextColor("last_rule_executed_on", apiData.assetSummary.data.metrics["last_rule_executed_on"]) }}>
                           {apiData.assetSummary.data.metrics["last_rule_executed_on"]}</CardValue>
                  </CardComp>
               </Fragment>
               {/* } */}
               {/* })} */}
            </div>

            <CardComp style={{ padding: "10px", marginTop: "10px", fontSize: "15pt", display: 'inline-block', width: "100%", height: cardHeight + "px", marginRight: '20px' }} title={
               <Fragment>
                  <div className="grid" style={{ borderBottom: `1px solid ${theme.colors.primary}` }}>
                     <div className="col-6"><GlobalCardTitle>Data Assets Details</GlobalCardTitle></div>
                     <div className="col-6" style={{ textAlign: "right" }}>
                        <UnderlineGlobalValue className="handCursor" onClick={() => setEnableSampleData(true)}>View Sample Data <i className="pi pi-folder" /></UnderlineGlobalValue>

                     </div>
                  </div>
               </Fragment>
            }
            >
               <div style={{ overflowX: "visible", overflowY: "hidden", whiteSpace: "normal", fontSize: "10pt", height: CardSectionHeight + "px" }}>
                  <div style={{ marginTop: "10px", marginBottom: "15px" }}><CardBodyTitle>Description</CardBodyTitle></div>
                  <Tooltip mouseTrack target=".dataAssetsDescription" />
                  <span style={{ fontSize: "12px" }} className="dataAssetsDescription" data-pr-tooltip={apiData.assetSummary.data.description}>{apiData.assetSummary.data.description}</span>
               </div>
               <hr style={{ margin: "15px 0", border: "1px solid #E7E7E7" }} />
               <div style={{ margin: "5px 0px", height: CardSectionHeight + "px", display: 'flex', justifyContent: 'space-between' }}>
                  <div style={{ textAlign: "left", fontSize: "12px" }} >
                     <CardBodyTitle>
                        Domain
                     </CardBodyTitle>
                     <div style={{ marginTop: "10px" }}>{apiData.assetSummary.data.domain}</div>
                  </div>
                  <div style={{ textAlign: "lfet", fontSize: "12px" }} >
                     <CardBodyTitle>
                        Sub-Domain
                     </CardBodyTitle>
                     <div style={{ marginTop: "10px" }}>{apiData.assetSummary.data.sub_domain}</div>
                  </div>
                  <div style={{ textAlign: "left", fontSize: "12px" }}>
                     <CardBodyTitle>
                        Cluster
                     </CardBodyTitle>
                     <div style={{ marginTop: "10px" }}>{apiData.assetSummary.data.region}</div>
                  </div>
                  <div style={{ textAlign: "left", fontSize: "12px" }}>
                     <CardBodyTitle>
                        Market
                     </CardBodyTitle>
                     <div style={{ marginTop: "10px" }}>{apiData.assetSummary.data.country}</div>
                  </div>
                  <div style={{ textAlign: "left", fontSize: "12px" }}>
                     <CardBodyTitle>
                        Data Steward
                     </CardBodyTitle>
                     <div style={{ marginTop: "10px" }}>{apiData.assetSummary.data.data_steward} </div>
                  </div>
                  <div style={{ textAlign: "left", fontSize: "12px" }}>
                     <CardBodyTitle>
                        Data Asset Owner
                     </CardBodyTitle>
                     <div style={{ marginTop: "10px" }}>{apiData.assetSummary.data.data_asset_owner}</div>
                  </div>
               </div>
            </CardComp>

            <CardComp
               title={
                  <Fragment>
                     <div className="grid" style={{ borderBottom: `1px solid ${theme.colors.primary}`,padding:'8px' }} >
                        <div className="col-3"><GlobalCardTitle style={{ verticalAlign: "sub" }}>{apiData.assetSummary.data.chartData.title}</GlobalCardTitle></div>
                        <div className="col-9 flex justify-content-end items-center" style={{ textAlign: "right" }}>
                           <Button type="button" onClick={() => {
                              updateChartTime(trendOption1)
                              setCurrentDisplayButton(trendOption1)
                           }} label={trendOption1} outlined={currentDisplayButton === trendOption1 ? false : true} style={{ marginRight: "10px", color: currentDisplayButton === trendOption1 ? "#ffffff" : "#333333", border: "1px solid #E7E7E7", marginTop: "5px", height: "40px" }} />
                           <Button type="button" onClick={() => {
                              updateChartTime(trendOption2)
                              setCurrentDisplayButton(trendOption2)
                           }} label={trendOption2} outlined={currentDisplayButton === trendOption2 ? false : true} style={{ marginRight: "10px", color: currentDisplayButton === trendOption2 ? "#ffffff" : "#333333", border: "1px solid #E7E7E7", marginTop: "5px", height: "40px" }} />
                           <Button type="button" onClick={() => {
                              updateChartTime(trendOption3)
                              setCurrentDisplayButton(trendOption3)
                           }} label={trendOption3} outlined={currentDisplayButton === trendOption3 ? false : true} style={{ marginRight: "10px", color: currentDisplayButton === trendOption3 ? "#ffffff" : "#333333", border: "1px solid #E7E7E7", marginTop: "5px", height: "40px" }} />
                       
                          

            <FloatLabel className='flex '>
                <Calendar
                style={{ marginTop: "5px", height: "40px" }}
                value={currentDisplayButton==='Custom'?dates:null} 
                inputId="custom_date"
                         
                           onSelect={()=>{ setCurrentDisplayButton("Custom")}}
                           onChange={(e) => {
                              updateChartTime("custom", e.value)
                              setDates(e.value)
                           }}
                            selectionMode="range" readOnlyInput hideOnRangeSelection
                              
                              // minDate={getMinDate()}
                              maxDate={new Date()}
                           /> 
                     <label style={{fontSize:'1rem'}} htmlFor="birth_date">Custom Date</label>
            
            </FloatLabel>
    
                        </div>
                     </div>
                  </Fragment>
               } style={{ padding: "10px", marginTop: "10px" }}>
             {Object.keys(chartOptions||{}).length>0 ?<ReactECharts
                  option={{
     
      tooltip: {
         trigger: 'axis',
         show: true,
         axisPointer: {
            type: 'cross',
            label: {
               backgroundColor: '#6a7985'
            }
         }
      },

      grid: {
         left: '3%',
         right: '4%',
         bottom: '3%',
         containLabel: true
      },
      xAxis: 
         {
            type: 'category',
            boundaryGap: false,
              data: Object.keys(chartOptions)
         }
      ,
      yAxis: 
         {
            type: 'value',
            min:0
         }
      ,
      series: [
           {
               areaStyle: {},
            emphasis: {
               focus: 'series'
            },
      data:Object.values(chartOptions),
      type: 'line'
    }
       
      ]
   }}
             
             
             
             

               />:<h3 style={{textAlign:'center'}}>No Data</h3>}
             
              
            </CardComp>
            {reUploadEnable ? <ReloadDataAssetFile changeDetail={changeDetail} onHide={() => { setReUploadEnable(false) }} /> : ""}
            {enableSampleData ? <SampleDataPopUp id={dataAssetId} onHide={() => { setEnableSampleData(false) }} /> : ""}
            {tagEnable ? <AssetSummaryTagPopUp dataAssetId={dataAssetId} tagArray={JSON.parse(apiData.assetSummary.data.tags)} changeDetail={changeDetail} onHide={() => { setTagEnable(false) }} /> : ""}
         </Container>}
   </Fragment>
}
export default AssetSummary